import Button from "@template/components/Button";
import PropTypes from "prop-types";
import sdkInstanceProvider from "@src/client/sdk/sdkInstanceProvider";

const SignInButton = ({ children }) => {
  const redirectToLogin = async () => {
    const { login } = await sdkInstanceProvider("identity");

    await login();
  };

  return (
    <Button onClick={redirectToLogin} theme="violet">
      {children}
    </Button>
  );
};

SignInButton.propTypes = {
  children: PropTypes.string.isRequired
};

export default SignInButton;
